import { useEffect } from "react";
import "./Homepage.css";
import Hero from "./Hero";
import HeroNav from "./HeroNav";
import LiquidBackdrop from "./LiquidBackdrop";

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <LiquidBackdrop />
      <HeroNav />

      <Hero />
    </div>
  );
};

export default Homepage;
